import styled, { css } from 'styled-components';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { checkBackground } from '../../utils/check-background';

const NONE_LANGUAGES_MESSAGE = 'No languages added';

export function EmptyMessage() {
  const { backgroundColor, ...settings } = useSettings();

  const hasBackgroundColor =
    !!backgroundColor && backgroundColor !== 'transparent';

  const hasBackground = checkBackground({ backgroundColor, ...settings });

  const invertedColor = hasBackgroundColor
    ? getInvertedColor(backgroundColor)
    : '#111';

  return (
    <Message
      _color={invertedColor}
      _hasBackground={hasBackground}
      role="status"
      aria-live="polite"
    >
      {NONE_LANGUAGES_MESSAGE}
    </Message>
  );
}

const Message = styled.div<{ _color: string; _hasBackground: boolean }>`
  ${({ _color, _hasBackground }) => css`
    color: ${_color};
    font-size: 13px;
    line-height: 16px;

    ${_hasBackground &&
    `
      border-radius: 8px;
      padding: 8px 12px;
    `}
  `}
`;
